import { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import { IntakeContext } from '../context/IntakeContext'
// import { Link } from "react-router-dom";

// @mui material components
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import Box from '@mui/material/Box'

// Soft UI Dashboard PRO React components

// Soft UI Dashboard PRO React icons
import CalculateIcon from '@mui/icons-material/Calculate'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import AssessmentIcon from '@mui/icons-material/Assessment'
import AssignmentIcon from '@mui/icons-material/Assignment'
import HelpIcon from '@mui/icons-material/Help'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import SquareRoundedIcon from '@mui/icons-material/SquareRounded'
import SavingsIcon from '@mui/icons-material/Savings'

const StyledMSB = styled.div`
  text-align: center;
  position: relative;
  padding: 16px;
  height: 100%;
  cursor: pointer;
  border: ${(props) =>
    props.active ? '2px solid #a3a7aa' : '2px solid #e5e5e5'};
  background: ${(props) => (props.active ? '#eeeeee' : '#fff')};
  color: #212121;
  border-radius: 0.75rem;
  transition: 0.2s all ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    border: 2px solid #a3a7aa;
    background: #f5f5f5;
  }

  > h6,
  h5 {
    color: #212121;
    letter-spacing: 0.3px;
    font-weight: 600;
    line-height: 1.4;
    margin: 0;
  }

  > span {
    border-radius: 50%;
    height: 1.5em;
    width: 1.5em;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.yesIcon {
      color: #4caf50;
      background-color: #dbefdc;
    }
    &.noIcon {
      color: #fd5c70;
      background-color: #fedee2;
    }
  }
`

const RetirementGoals = () => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)

  const goalList = {
    goalAffordToRetire: intakeState?.goalAffordToRetire,
    goalEarliestEligibility: intakeState?.goalEarliestEligibility,
    goalMaximizeFederalBenefit: intakeState?.goalMaximizeFederalBenefit,
    goalHelpFillingOutForms: intakeState?.goalHelpFillingOutForms,
    goalCalculateRetirementNumbers: intakeState?.goalCalculateRetirementNumbers,
    goalHelpInvestmentsTs: intakeState?.goalHelpInvestmentsTs,
  }

  const [retirementGoals, setRetirementGoals] = useState(goalList)

  const toggleGoal = (goal) => {
    setRetirementGoals({ ...retirementGoals, [goal]: !retirementGoals[goal] })
  }

  useEffect(() => {
    updateIntakeStateAtKey(retirementGoals)
  }, [retirementGoals])

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          How can we help you better prepare for retirement?
        </Typography>
      </Box>
      <Typography variant="body1" fontSize={{ xs: '16px', sm: '20px' }}>
        Select the options that you would like our team to help you with:
      </Typography>
      <Box mt={2}>
        <Grid container spacing={1} justifyContent="center" mb={3}>
          <Grid item xs={6}>
            <StyledMSB
              active={retirementGoals['goalAffordToRetire']}
              onClick={() => toggleGoal('goalAffordToRetire')}
            >
              <Icon fontSize="large">
                <SavingsIcon />
              </Icon>
              <Typography variant="h6" textTransform="capitalize">
                Determine if I can afford to retire
              </Typography>
            </StyledMSB>
          </Grid>
          <Grid item xs={6}>
            <StyledMSB
              active={retirementGoals['goalEarliestEligibility']}
              onClick={() => toggleGoal('goalEarliestEligibility')}
            >
              <Icon fontSize="large">
                <EventAvailableIcon />
              </Icon>
              <Typography variant="h6" textTransform="capitalize">
                Find my earliest retirement eligibility date
              </Typography>
            </StyledMSB>
          </Grid>
          <Grid item xs={6}>
            <StyledMSB
              active={retirementGoals['goalMaximizeFederalBenefit']}
              onClick={() => toggleGoal('goalMaximizeFederalBenefit')}
            >
              <Icon fontSize="large">
                <AssessmentIcon />
              </Icon>
              <Typography variant="h6" textTransform="capitalize">
                Maxmize my federal benefits
              </Typography>
            </StyledMSB>
          </Grid>
          <Grid item xs={6}>
            <StyledMSB
              active={retirementGoals['goalHelpFillingOutForms']}
              onClick={() => toggleGoal('goalHelpFillingOutForms')}
            >
              <Icon fontSize="large">
                <AssignmentIcon />
              </Icon>
              <Typography variant="h6" textTransform="capitalize">
                Help with government forms or retirement paperwork
              </Typography>
            </StyledMSB>
          </Grid>
          <Grid item xs={6}>
            <StyledMSB
              active={retirementGoals['goalHelpInvestmentsTs']}
              onClick={() => toggleGoal('goalHelpInvestmentsTs')}
            >
              <Icon fontSize="large">
                <SquareRoundedIcon />
              </Icon>
              <Icon fontSize="medium">
                <TrendingUpIcon />
              </Icon>
              <Typography variant="h6" textTransform="capitalize">
                Get help with Investments & TSP
              </Typography>
            </StyledMSB>
          </Grid>
          <Grid item xs={6}>
            <StyledMSB
              active={retirementGoals['goalCalculateRetirementNumbers']}
              onClick={() => toggleGoal('goalCalculateRetirementNumbers')}
            >
              <Icon fontSize="large">
                <HelpIcon />
              </Icon>
              <Typography variant="h6" textTransform="capitalize">
                Something Else
              </Typography>
            </StyledMSB>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default RetirementGoals
